import { Dialog } from "@mui/material";
import { X } from "lucide-react";
import React from "react";
import ComparisonTable from "./ComparisonTable";
import { useGetAllComparisonLogsQuery } from "./AuditLogAPIS";

const ActivityLogComparison = ({ open, onClose, Data }) => {
  const {
    data: comparisonData,
    isLoading,
    isError,
  } = useGetAllComparisonLogsQuery({ id: Data?.id }, { skip: !open || !Data?.id });

  const oldData = comparisonData?.old_data?.[0] || {};
  const newData = comparisonData?.new_data || {};

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <div className="bg-white rounded-xl w-full max-h-[85vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#DFE2E5]">
          <h2 className="text-base font-bold text-[#004EFF]">{Data?.module}</h2>
          <button onClick={onClose}>
            <X className="w-6 h-6 text-[#868D96]" />
          </button>
        </div>

        <div className="overflow-y-auto thinscrollbar max-h-[50vh] m-3 ">
          <ComparisonTable oldData={oldData} newData={newData} />
        </div>
      </div>
    </Dialog>
  );
};

export default ActivityLogComparison;
